import { render } from "./DocumentsSettingsSection.vue?vue&type=template&id=dac8571e"
import script from "./DocumentsSettingsSection.vue?vue&type=script&lang=js"
export * from "./DocumentsSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__